import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  CUSTOMER_ADD_REQUEST,
  CUSTOMER_ADD_SUCCESS,
  CUSTOMER_ADD_FAILURE,
  CUSTOMER_EDIT_REQUEST,
  CUSTOMER_EDIT_SUCCESS,
  CUSTOMER_EDIT_FAILURE,
  CUSTOMER_VIEW_REQUEST,
  CUSTOMER_VIEW_SUCCESS,
  CUSTOMER_VIEW_FAILURE,
  CUSTOMER_VIEW_ALL_REQUEST,
  CUSTOMER_VIEW_ALL_SUCCESS,
  CUSTOMER_VIEW_ALL_FAILURE,
  CUSTOMER_DELETE_REQUEST,
  CUSTOMER_DELETE_SUCCESS,
  CUSTOMER_DELETE_FAILURE,
  CUSTOMER_RESET_STATE,
  CUSTOMER_SEARCH_SUCCESS,
  CUSTOMER_SEARCH_REQUEST,
  CUSTOMER_SEARCH_FAILURE,
} from "./CustomerTypes";

const initialState = {
  addCustomer: { ...defaultStatus },
  editCustomer: { ...defaultStatus },
  deleteCustomer: { ...defaultStatus },
  viewCustomer: { ...defaultStatus },
  viewAllCustomer: { ...defaultStatus },
  viewAllSearchCustomer: { ...defaultStatus },
};

const CustomerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // Add Bar/Club Cases
    case CUSTOMER_ADD_REQUEST:
      return {
        ...state,
        addCustomer: { ...defaultStatus, inProgress: true, ...payload },
      };
    case CUSTOMER_ADD_SUCCESS:
      return {
        ...state,
        addCustomer: { ...defaultStatus, success: true, ...payload },
      };
    case CUSTOMER_ADD_FAILURE:
      return {
        ...state,
        addCustomer: { ...defaultStatus, error: true, ...payload },
      };

    // Edit Bar/Club Cases
    case CUSTOMER_EDIT_REQUEST:
      return {
        ...state,
        editCustomer: { ...defaultStatus, inProgress: true, ...payload },
      };
    case CUSTOMER_EDIT_SUCCESS:
      return {
        ...state,
        editCustomer: { ...defaultStatus, success: true, ...payload },
      };
    case CUSTOMER_EDIT_FAILURE:
      return {
        ...state,
        editCustomer: { ...defaultStatus, error: true, ...payload },
      };

    // View Bar/Club Cases
    case CUSTOMER_VIEW_REQUEST:
      return {
        ...state,
        viewCustomer: { ...defaultStatus, inProgress: true, ...payload },
      };
    case CUSTOMER_VIEW_SUCCESS:
      return {
        ...state,
        viewCustomer: { ...defaultStatus, success: true, ...payload },
      };
    case CUSTOMER_VIEW_FAILURE:
      return {
        ...state,
        viewCustomer: { ...defaultStatus, error: true, ...payload },
      };

    // View All Bars/Clubs Cases
    case CUSTOMER_VIEW_ALL_REQUEST:
      return {
        ...state,
        viewAllCustomer: { ...defaultStatus, inProgress: true, ...payload },
      };
    case CUSTOMER_VIEW_ALL_SUCCESS:
      return {
        ...state,
        viewAllCustomer: { ...defaultStatus, success: true, ...payload },
      };
    case CUSTOMER_VIEW_ALL_FAILURE:
      return {
        ...state,
        viewAllCustomer: { ...defaultStatus, error: true, ...payload },
      };

    //Customer Search View All
    case CUSTOMER_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchCustomer: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case CUSTOMER_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchCustomer: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case CUSTOMER_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchCustomer: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    // Delete Bar/Club Cases
    case CUSTOMER_DELETE_REQUEST:
      return {
        ...state,
        deleteCustomer: { ...defaultStatus, inProgress: true, ...payload },
      };
    case CUSTOMER_DELETE_SUCCESS:
      return {
        ...state,
        deleteCustomer: { ...defaultStatus, success: true, ...payload },
      };
    case CUSTOMER_DELETE_FAILURE:
      return {
        ...state,
        deleteCustomer: { ...defaultStatus, error: true, ...payload },
      };

    // Reset State Case
    case CUSTOMER_RESET_STATE:
      return {
        ...initialState,
      };

    // Default Case
    default:
      return state;
  }
};

export default CustomerReducer;
